// @ts-ignore

import traverseISODate from '@segment/isodate-traverse';

import { type EventOverrides } from '../types';

import { nestedRemoveUndefinedValues } from './util';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const prepareEventProperties = <T extends object>(properties: T): T => {
	const propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties, '$.properties');

	// Remove any override properties that shouldn't be included in the event body
	delete (propertiesWithoutUndefined as EventOverrides).excludedProperties;
	delete (propertiesWithoutUndefined as EventOverrides).userConsents;

	return traverseISODate(propertiesWithoutUndefined);
};
